/*
 *   File : otp-input.js
 *   Author : https://evoqins.com
 *   Description : OTP input component
 *   Integrations : NA
 *   Version : 1.0.0
*/

//custom style
import { useEffect, forwardRef, memo, useState, useRef } from "react";

//styles
import styles from "../../Styles/Component/input.module.scss";


const OTPInput = forwardRef((props, ref) => {

    const [pin, setPin] = useState(props.value);
    const otpLabelInputRef = useRef(null);
    const [inputWidth, setInputWidth] = useState(0);

    useEffect(() => {
        setPin(props.value);
    }, [props.value]);

    useEffect(() => {
        setInputWidth(otpLabelInputRef.current.clientWidth);
    }, [otpLabelInputRef.current]);

    useEffect(() => {

        if (ref && props.focused_input === 2 && props.value.length <= 4) {
            ref.current.focus();
        };

    }, [props.focused_input]);

    const _handleOtpChange = (event) => {

        const value = event.target.value;
        const allowedValues = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", ""];
        if (allowedValues.includes(value.slice(-1)) === false) return;
        setPin(value);
        props.onChange(value);

    };

    const _preventDefaults = (e) => {
        const key_code = e.keyCode || e.which;
        const is_ctrl_pressed = e.ctrlKey || e.metaKey; // Check if Ctrl key is pressed

        if (e.keyCode === 13) {
            props.onKeyPress();
        }

        if (key_code === 9 || // Tab key
            (is_ctrl_pressed && (key_code === 65 || key_code === 67 || key_code === 88 || key_code === 86))
        ) {
            // Ctrl+A, Ctrl+C, Ctrl+X, or Ctrl+V    
            e.preventDefault();
        }

        if (
            (key_code >= 48 && key_code <= 57) || // 0-9
            (key_code >= 96 && key_code <= 105) || // Numpad 0-9
            key_code === 8 || // Backspace
            (key_code >= 37 && key_code <= 40) // Arrow keys
        ) {
            // Allow the keypress
        } else {
            e.preventDefault();
        }
    };

    return (
        <div className={props.wrapperClass}>
            {props.label &&
                <label className={`${props.labelStyle} e-text-chinese-black e-font-14 e-alt-font-lato  e-font-weight-500 line-height-20px padding-4px-bottom`}>
                    {props.label}
                    {props.require &&
                        <span className='e-text-vermilion'>*</span>
                    }
                </label>
            }
            <div className={`${styles.e_otp_wrapper} position-relative d-flex flex-column align-items-start mt-2 user-select-none`}>
                <input
                    style={{ width: inputWidth + "px" }}
                    type="text"
                    ref={ref}
                    maxLength={4}
                    id={props.id}
                    value={pin}
                    spellCheck={props.spellCheck}
                    className={`mb-0 e-caret-color-transparent`}
                    onFocus={props.onFocus}
                    onBlur={props.onBlur}
                    autoComplete="off"
                    autoFocus={props.autoFocus}
                    tabIndex={props.tabIndex}
                    onChange={_handleOtpChange}
                    onKeyDown={_preventDefaults} />


                <label ref={otpLabelInputRef} className='d-flex gap-12px' onClick={props.onFocus}>
                    <div className={`justify-content-center w-40px-res h-40px-res w-56px h-56 e-font-weight-500 e-font-16 line-height-20px e-inline-flex e-alt-font-lato 
                ${props.focused_input === 2 ? 'e-border-otp-active' : 'e-border-otp'}`}>
                        {
                            pin.length !== 0 ?
                                <span className="pt-1 e-text-chinese-black">*</span> :
                                <span className="pt-2"></span>
                        }
                    </div>
                    <div className={`justify-content-center w-40px-res h-40px-res w-56px h-56 e-font-weight-500 e-alt-font-lato e-font-16 line-height-20px e-inline-flex
                 ${props.focused_input === 2 && pin.length >= 2 ? 'e-border-otp-active' : 'e-border-otp'}`}>
                        {
                            pin.length >= 2 ?
                                <span className="pt-1 e-text-chinese-black">*</span> :
                                <span className={`pt-2`}></span>
                        }
                    </div>
                    <div className={`justify-content-center w-40px-res h-40px-res w-56px h-56 e-font-weight-500 e-alt-font-lato e-font-16 line-height-20px e-inline-flex
                 ${props.focused_input === 2 && pin.length >= 3 ? 'e-border-otp-active' : 'e-border-otp'}`}>
                        {
                            pin.length >= 3 ?
                                <span className="pt-1 e-text-chinese-black">*</span> :
                                <span className={`pt-2`}></span>
                        }
                    </div>
                    <div className={`justify-content-center w-40px-res h-40px-res w-56px h-56 e-font-weight-500 e-alt-font-lato e-font-16 line-height-20px e-inline-flex 
                ${props.focused_input === 2 && pin.length >= 4 ? 'e-border-otp-active' : 'e-border-otp'}`}>
                        {
                            pin.length >= 4 ?
                                <span className="pt-1 e-text-chinese-black">*</span> :
                                <span className={`pt-2`}></span>
                        }
                    </div>
                </label>

                {props.error &&
                    <p className={`${styles.e_error_message} bottom--14px position-absolute mb-0 e-text-vermilion e-alt-font-lato e-font-12 line-height-12px pt-1 e-font-weight-500`}>
                        {props.error}
                    </p>
                }
            </div>
        </div>
    )
});

OTPInput.defaultProps = {
    onKeyPress: () => { },
    className: null,
    error: "",
}

export default memo(OTPInput);